<template>
  <div>
    <SignaturePad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="signatureData"
    />
    <v-card min-height="40vh">
      <v-col
        cols="12"
        class="white--text text-uppercase text-center text-caption"
        style="background-color: #2b3990; "
      >{{ title }}
      </v-col>
      <v-col cols="12" md="12">
        <p class="text-caption">
          It is with great pleasure that we welcome you to {{ userCompany }}!
          We're excited to add another person to our growing
          team. We are looking forward to getting you ingrained in the
          lives of our clients. Over the following weeks and several
          months, you will be working closely with our team to get to
          know the needs, wants and behaviors of our clients. Our clients
          have a vast array of interests as well as behaviors. No two days
          will be alike at {{ userCompany }}! Please understand that any of
          our clients can display extreme, negative behaviors. These behaviors
          will happen, and you will receive training on how to best work with
          our clients while they are displaying such behaviors. Our clients will
          spit, swear, hit, kick, bite, scratch, strip, throw things, break things
          and do anything they deem necessary to try to communicate with us. There
          is a good chance you will be bruised or injured; we do provide appropriate
          medical care and treatment through our Workers' Compensation insurance program.
          While these behaviors are nor appropriate, we are always working on better ways
          for our clients to communicate their needs and wants.
        </p>
        <p class="text-caption">
          We sincerely hope you will become a positive role model for our
          clients, especially in their most challenging times. That is when they
          need us the most. Please acknowledge below that you are aware that you
          will be working with clients that have extreme, negative behaviors.
        </p>
        <p class="text-caption">
          I understand that I will be working with clients that have extreme,
          negative behaviors and I will constantly work with the clients to improve
          their extreme, negative behaviors.
        </p>
        <p class="text-caption">
          By signing below, I acknowledge that I have read, understand, and agree to adhere to the
          18/6 Rule as outlined.
        </p>


      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="item.employeeName"
              label="Employee Name (print)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <div style="position: relative">
              <v-text-field
                label="Employee's Signature"
                @click.stop="showSignaturePad = true"
              ></v-text-field>
              <v-img
                width="150"
                height="50"
                :src="employeeSignatureInExtreme"
                style="position:absolute;top:10px;right:150px;"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-menu
              ref="menu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateSignedInExtremeBehavior"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="dateSignedInExtremeBehavior"
                @input="dateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-row align="center" justify="start">
              <v-card-actions>
                <v-btn @click="prev">Prev</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="end">
              <v-card-actions>
                <v-btn @click="next">Next</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </div>
</template>
<script>
/* eslint-disable */
import SignaturePad from "@/components/SignaturePad";
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import download from "downloadjs";

export default {
  components: {SignaturePad},
  props: {
    title: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
  },
  data: function () {
    return {
      dateMenu: false,
      employeeSignature: "",
      showSignaturePad: false,
      item: {},
      step: this.currentStep,
    };
  },

  created() {
    this.populateUserInfo();
    const savedSignature = localStorage.getItem("employeeSignatureInExtreme");
    if (savedSignature) {
      this.signatureData(savedSignature);
    }
  },

  computed: {
    ...mapGetters("userDocuments", ["getUserDocuments"]),
    ...mapGetters("users", {
      user: "user",
      userCompany: "userCompany",
    }),
  },

  methods: {
    ...mapActions({
      getDocuments: "userDocuments/getDocuments",
      addTransportationDoc: "userDocuments/saveTransportationDocument",
      addDocument: "userDocuments/updateDocument",
      downloadDocuments: "userDocuments/downloadDocuments",
    }),
    signatureData(data) {
      this.employeeSignatureInExtreme = data;
      localStorage.setItem("employeeSignatureInExtreme", data);
    },

    next() {
      this.addItem();
      // this.generatePDF();
      this.$emit("clicked", this.step + 1);
    },
    prev() {
      this.$emit("clicked", this.step - 1);
    },
    async addItem() {
      try {
        const response = await this.addDocument({
          data: {...this.item, Employee: this.user._id},
          pdfDocument: "client-transportation-agreement",
        });
        console.log(response);
        localStorage.setItem('dateSignedInExtremeBehavior', this.dateSignedInExtremeBehavior);
      } catch (error) {
        console.log(error);
      }
    },

    async populateUserInfo() {

      const dateSigned = localStorage.getItem('dateSignedInExtremeBehavior');

      if (dateSigned !== null) {
        this.dateSignedInExtremeBehavior = dateSigned;
      }

      this.item.employeeName = this.user.Name;

      const response = await this.getDocuments(this.user._id);

      let documents = this.updateCase(
        response.data.document.Documents.ClientTransportationAgreement
      );

      this.item = Object.assign(
        {},
        {
          ...documents,
          employeeName: response.data.document.Employee.Name,
        }
      );
    },

    async generatePDF() {
      const response = await this.downloadDocuments({
        id: this.user._id,
        pdfDocument: "client-transportation-agreement",
      });
      let pdfFile =
        "data:application/octet-stream;base64," + response.data.data;
      download(
        pdfFile,
        "client-transportation-agreement.pdf",
        "application/pdf"
      );
    },

    updateCase(obj) {
      let output = Object.entries(obj).map(([key, value]) => [
        key[0].toLowerCase() + key.slice(1),
        value,
      ]);
      return Object.fromEntries(output);
    },
  },
};
</script>
<style scoped>
.theme--light.v-btn.v-btn--has-bg {
  background-color: #2b3990;
  color: #fff;
  border-radius: 1.25rem;
}
</style>
